(function () {
  var utmKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  var params = new URLSearchParams(window.location.search);

  utmKeys.forEach(function (key) {
    var value = params.get(key);

    if (value) {
      sessionStorage.setItem('marketing_' + key, value);
    }
  });
})();